import { inject } from "@angular/core";
import { Router } from "@angular/router";

import { AuthService } from "@core/services/auth.service";
import { LoggerService } from "@core/services/logger.service";
import { LoginRoutesConstants } from "@login/routes/login.routes.constants";
import { UserRole } from "@shared/models/user.model";

export const adminRoleGuard = async (): Promise<boolean> => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const logger = inject(LoggerService);

  try {
    // First check if user is authenticated
    if (!authService.isLoggedIn()) {
      logger.debug("No user in memory, trying to initialize auth...");
      const initialized = await authService.initializeAuth();

      if (!initialized) {
        logger.debug("Auth initialization failed, redirecting to login");
        await router.navigate([LoginRoutesConstants.main()]);
        return false;
      }
    }

    // Check if user has the required admin role
    const user = authService.currentUser();
    if (!user) {
      logger.debug("User not found, redirecting to login");
      await router.navigate([LoginRoutesConstants.main()]);
      return false;
    }

    // Check if user has SUPER_ADMIN or ORGANIZATION_ADMIN role
    if (user.role !== UserRole.SUPER_ADMIN && user.role !== UserRole.ORGANIZATION_ADMIN) {
      logger.debug(`User role ${user.role} is not authorized to access admin routes`);
      await router.navigate(["/"]); // Redirect to home page
      return false;
    }

    return true;
  } catch (error: any) {
    logger.error("Unexpected error in admin role guard:", error);
    await router.navigate([LoginRoutesConstants.main()]);
    return false;
  }
};
